import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import Vuex from 'vuex'
import router from '../router/router'
import axios from 'axios';
import VueMeta from 'vue-meta'
import VueGtag from "vue-gtag"
import { GA_MEASUREMENT_ID } from '../analyticsConfig.js'
import languageCodes from "./language-codes.js";
// import logger from "./logger.js";
// import { VueMasonryPlugin } from "vue-masonry";

import firebase from '../firebaseConfig.js'
import store from './store'


// Vue.use(VueMasonryPlugin);
Vue.use(Vuex)
Vue.use(VueMeta)
/* google analytics tracking for vue */
Vue.use(VueGtag, {
    config: { id: GA_MEASUREMENT_ID },
    enabled: process.env.NODE_ENV === 'production' && window.location.host != '0-0-0-dot-tawq-in-www.appspot.com' ? true : false,
    // enabled: process.env.NODE_ENV === 'development' ? true : false,
    bootstrap: false,
}, router)

// import Hotjar from 'vue-hotjar'
// Vue.use (Hotjar, {
//     id: '2791229',
//     isProduction: process.env.NODE_ENV === 'production' ? true : false,
// })

Vue.prototype.$navigator = window.navigator;
Vue.prototype.$window = window;
Vue.config.productionTip = false;
Vue.prototype.$http = axios;
// Vue.prototype.$log = Logger;
// Vue.prototype.$log = (p1, p2, p3) => {
//     logger.log(p1,p2,p3);
// };

// Vue.prototype.$setLoggerAdmin = (admin) => {
//     logger.setAdmin(admin);
// }
// Any language that we would like to add from google can be inserted below
Vue.prototype.$languageCodes = languageCodes.languageCodes;

axios.defaults.baseURL = "https://tawq-in-create.appspot.com";
// axios.defaults.baseURL = "http://localhost:8000";
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.put['Content-Type'] = 'application/json';


/* request interceptor: attach a fresh Firebase ID token to every outgoing request */
axios.interceptors.request.use(async (config) => {
    const user = firebase.auth.currentUser;
    if (user) {
        const token = await user.getIdToken();
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});


/* response interceptor */
axios.interceptors.response.use((response) => {
    if (response.status == 200 || response.status == 201 || response.status == 308){
        // This is called 4 times when initializing the store (index.js).
        // This is because on initialization, the store calls the server to get all the stripe
        // information for the current user. We get the CUSTOMER, SUBSCRIPTION, INVOICES and PRODUCT.
        return response;
    }
}, async (error) => {
    if (error.response){
        if (error.response.status == 308){
            return error.response;
        }
        const originalRequest = error.config;
        /* The server will send a 401 response if the api key has become expired. When it does, we will request a new one and resend the original request */
        if (error.response.status === 401 && !originalRequest._retry){
            if(firebase.auth.currentUser){
                /* get a new token, then re send the original request only one time! */
                originalRequest._retry = true;
                let token = await firebase.auth.currentUser.getIdToken();
                Vue.prototype.$apiKey = token;
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                originalRequest.headers.Authorization = `Bearer ${token}`;
                return axios(originalRequest);
            } else {
                console.error("401 reponse but no firebase user");
            }
        }
        else if (error.response.status === 403){
            //TODO: log them out!
            console.error("Error:", error.response.status)
        }
    }
    return Promise.reject(error);
});


let app;

function waitForStoreValue(getterFn, { timeoutMs = 8000, intervalMs = 50 } = {}) {
    return new Promise((resolve, reject) => {
        const start = Date.now();
        const t = setInterval(() => {
            const val = getterFn();
            if (val !== null && val !== undefined) {
                clearInterval(t);
                resolve(val);
            } else if (Date.now() - start > timeoutMs) {
                clearInterval(t);
                reject(new Error("Timed out waiting for store value"));
            }
        }, intervalMs);
    });
};

export { waitForStoreValue };

firebase.auth.onAuthStateChanged(async (user) => {
    // console.log("Firebase auth state changed detected in main.js");
    try {
        if (user) {
            // 🔐 Get fresh ID token
            const tokenResult = await user.getIdTokenResult(true);
            Vue.prototype.$apiKey = tokenResult.token;
            axios.defaults.headers.common["Authorization"] = `Bearer ${tokenResult.token}`

            // Ensure doc exists (optional: keep your create logic here)
            const docRef = firebase.db.collection("userData").doc(user.uid);
            const doc = await docRef.get();
            if (!doc.exists) {
                await store.dispatch("createUserDataInFirebaseFirestore", user); // or however you do it
            }

            // Bind via vuexfire
            await store.dispatch("initializeStore", user);

            // Make 100% sure userData is present before reading preferences
            await waitForStoreValue(() => store.state.userData);

            const prefersDark = !!store.state.userData?.darkTheme;
            vuetify.framework.theme.dark = prefersDark;
        } else {

            delete Vue.prototype.$apiKey;
            delete axios.defaults.headers.common["Authorization"];

            // IMPORTANT: unbind on sign-out so stale data doesn't linger
            await store.dispatch("unbindUserFriendsData");
            await store.dispatch("unbindUserGroupsData");
            await store.dispatch("unbindUserData");

            vuetify.framework.theme.dark = true;
        }
    } finally {
        // Mount once
        if (!app) {
            app = new Vue({ el: '#app', router, store, vuetify, render: (h) => h(App), }).$mount("#app");
            // app = new Vue({ el: '#app', router, vuetify, store, render: h => h(App),}).$mount('#app');
        }
    }
});






/*** OLD CODE BELOW COMMENTED OUT BY SCOTT BRADY ON JANUARY 8, 2026 ***/

// let app = null;
// firebase.auth.onAuthStateChanged(async (user) => {
//     console.log("Firebase auth state changed detected in main.js");
//     // 1) Always put the user into store first (or clear it)
//     await store.dispatch("bindUserData", user);

//     if (user) {
//         const userDocRef = firebase.db.collection("userData").doc(user.uid)
//         const userDoc = await userDocRef.get();
//         if (!userDoc.exists) {
//             await store.dispatch("createUserDataInFirebaseFirestore");
//             const newlyCreatedUserDoc = await userDocRef.get();
//         }
//         // console.log("Fetched user document:", userDoc.data());
//     }

// });
// firebase.auth.onAuthStateChanged(() => {
//     /* only try to get a token if there is a current user, if there is not
//         still load the app without the api token */
//     if (firebase.auth.currentUser) {
//         firebase.auth.currentUser.getIdTokenResult().then((token) => {
//             Vue.prototype.$apiKey = token.token;
//             axios.defaults.headers.common['Authorization'] = `Bearer ${token.token}`;
//             if (!app) {
//                 app = new Vue({ el: '#app', router, vuetify, store, render: h => h(App),}).$mount('#app');
//             }
//         }).catch(err => {
//             console.error("API connection issues", err);
//             if (!app) {
//                 app = new Vue({ el: '#app', router, vuetify, store, render: h => h(App),}).$mount('#app');
//             }
//         })
//     } else {
//         if (!app) {
//             app = new Vue({ el: '#app', router, vuetify, store, render: h => h(App),}).$mount('#app');
//         }
//     }
// })